<template>
  <el-switch
    v-model="switchValue"
    :active-text="statusText"
    :disabled="disabled"
    :class="{ spaced: spaced }"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'Toggle',

  props: {
    value: {
      required: false
    },

    text: {
      type: String
    },

    activeText: {
      type: String
    },

    inactiveText: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    },

    spaced: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    statusText() {
      if (this.text) {
        return this.text
      }

      return this.switchValue ? this.activeText : this.inactiveText
    },

    switchValue: {
      get() {
        return this.value
      },

      set(switchValue) {
        this.$emit('input', switchValue)
      }
    }
  }
}
</script>

<style scoped>
.spaced {
  height: 38px;
  line-height: 38px;
}

>>> .el-switch__label {
  color: #7e8596;
}
>>> .el-switch__label.is-active {
  color: #5c6374;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/Toggle.vue